/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Intro_EyebrowInputs */

const tr_landing_intro_eyebrow = /** @type {(inputs: Landing_Intro_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piyasadaki durum`)
};

const en_landing_intro_eyebrow = /** @type {(inputs: Landing_Intro_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`State of the market`)
};

const de_landing_intro_eyebrow = /** @type {(inputs: Landing_Intro_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Lage am Markt`)
};

const ru_landing_intro_eyebrow = /** @type {(inputs: Landing_Intro_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ситуация на рынке`)
};

/**
* | output |
* | --- |
* | "State of the market" |
*
* @param {Landing_Intro_EyebrowInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_intro_eyebrow = /** @type {((inputs?: Landing_Intro_EyebrowInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Intro_EyebrowInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_intro_eyebrow(inputs)
	if (locale === "de") return de_landing_intro_eyebrow(inputs)
	if (locale === "ru") return ru_landing_intro_eyebrow(inputs)
	return tr_landing_intro_eyebrow(inputs)
});